import { Box, IconButton, IconCloseX24 } from '@stitch-fix/mode-react';
export type CloseButtonProps = {
  onClick: () => void;
};
export const CloseButton = ({
  onClick
}: CloseButtonProps) => <Box width="100%" style={{
  display: 'flex',
  justifyContent: 'flex-end'
}}>
    <IconButton type="button" aria-label="Close" onClick={onClick}>
      <IconCloseX24 color="blue-45" />
    </IconButton>
  </Box>;